export default __webpack_public_path__ + "5536019f377d9774fc7f29168d061d52.png";